import React, {Component, Fragment} from 'react';
import PropTypes, {instanceOf} from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import {connect} from 'react-redux';
import {getNewsList} from '../actions';
import Link from "react-router-dom/Link";
import {withCookies, Cookies} from 'react-cookie';
import '../assets/scss/snackbarLastNews.css';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../translations/translations_snackbar_last_news';

const styles = {
    action: {
        position: 'absolute',
        top: '10px',
        right: '15px',
    }
};

class SnackbarLastNews extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    state = {
        open: false,
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    handleClose = (e) => {
        const {cookies} = this.props;

        this.setState({open: false});

        cookies.set('snackbar_last_news_closed', 'yes', { path: '/' });
    };

    componentDidMount() {
        const {cookies} = this.props;

        const snackbarClosed = cookies.get('e') || 'no';

        if (snackbarClosed !== 'yes') {
            this.setState({open: true});

            // Fetch the news
            this.props.getNewsList(
                1, // No offset
                true, // Reset the search results / listing
            );
        }
    }

    render() {
        const {newsList, newsListLoading} = this.props.news;
        const {classes} = this.props;

        if (!newsListLoading && newsList.length > 0) {

            let copyNewsList = newsList.slice(0);
            const lastNew = copyNewsList.shift();

            const uri = this.props.translate('routes.news_details').replace(':slug', lastNew.slug);

            const message =
                <div className="news-content">
                    <span className="title">{ReactHtmlParser(lastNew.title)}</span>
                    <div className="excerpt">{ReactHtmlParser(lastNew.excerpt)}</div>
                    <Button variant="outlined" color="secondary" className="btn-more" component={props => <Link to={uri} {...props}/>} onClick={this.handleClose}>
                        <Translate id="snackbar_last_news.button_read_more" />
                    </Button>
                </div>;

            return (
                <Snackbar
                    className="snackbar-last-news"
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={this.state.open}
                    autoHideDuration={20000}
                    onClose={this.handleClose}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                >
                    <SnackbarContent
                        classes={{
                            action: classes.action
                        }}
                        className="snackbar-content"
                        message={message}
                        action={[
                            <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                className="btn-close"
                                onClick={this.handleClose}
                            >
                                <CloseIcon />
                            </IconButton>,
                        ]}
                    />
                </Snackbar>
            );
        } else {
            return (<Fragment></Fragment>);
        }
    }
}

SnackbarLastNews.propTypes = {
    getNewsList: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    news: state.news
});

export default withCookies(connect(mapStateToProps, {getNewsList})(withStyles(styles)(withLocalize(SnackbarLastNews))));


// WEBPACK FOOTER //
// ./src/features/News/components/SnackbarLastNews.js